import React from 'react';
import { useIsLarge } from '../../../shared/theme';
import FundTypeFilter from './filter-components/fund-type-filter';
import AssetClassFilter from './filter-components/asset-class-filter';
import NameFilter from './filter-components/name-filter';
import NameFilterButton from './filter-components/name-filter-button';
import TypeAndAssetClassFilter from './filter-components/type-and-asset-class-filter';

export default function Filters(props) {
  const isLarge = useIsLarge();

  return (
    <>
      {!isLarge && <NameFilterButton />}
      {isLarge && <FundTypeFilter />}
      {isLarge && <AssetClassFilter />}
      {!isLarge && <TypeAndAssetClassFilter />}
      {isLarge && <NameFilter {...props} />}
    </>
  );
}
